module.exports = __webpack_public_path__ + "img/icon-pack-magento-1.d5e3c9c3.svg";